import { makeStyles } from '@mui/styles';
// colors
import { colors } from '../../../../../../packages/colors';

export const useStyles = makeStyles({
  recommendationCard: {
    padding: '24px 16px',
    borderRadius: '12px',
    backgroundColor: colors.white,
    boxShadow:
      '0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06), 0px 0px 1px 0px rgba(0, 0, 0, 0.04)',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  cardTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: colors.neutral900,
    lineHeight: '24px',
    textAlign: 'center',
  },
  cardSubTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: colors.neutral900,
    lineHeight: '20px',
  },
  cardDescription: {
    fontSize: '14px',
    fontWeight: 500,
    color: colors.neutral700,
    lineHeight: '20px',
  },
  cardAction: {
    color: `${colors.primary500} !important`,
    fontSize: '14px !important',
    fontWeight: '700 !important',
    padding: '0 !important',
    textTransform: 'none !important',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
});
